import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FontAwesomeService {

  // Icons are kept in localStorage too, so a browser downloads each one only once.
  // Bump the version when the icons on the blob change, to drop the stored ones.
  private static storagePrefix = 'fa_icon_v1_';

  private _cache = {};

  private _loading = {};

  constructor(private http: HttpClient) { }

  getIcon(dir, file): Observable<string> {
    // console.log(`https://fontawesome.blob.core.windows.net/${dir}/${file}.svg`);
    var key = dir + '_' + file;

    if (!this._cache[key]) {
      var stored = this.loadStored(key);
      if (stored) this._cache[key] = stored;
    }

    if (this._cache[key]) {
      return new Observable(observer => { observer.next(this._cache[key]) });
    }

    if (this._loading[key]) {
      return this._loading[key];
    }

    this._loading[key] = new Subject<string>();

    this.http
      .get(`https://fontawesome.blob.core.windows.net/${dir}/${file}.svg`, { responseType: 'text' })
      .subscribe(d => {
        this._cache[key] = d;
        this.store(key, d);
        this._loading[key].next(d);
        this._loading[key] = null;
      });

    return this._loading[key];
  }

  // storage can be unavailable (server rendering, private mode, blocked or full),
  // the icons then just load over the network as before
  private loadStored(key: string): string {
    try {
      return typeof localStorage === 'undefined' ? null : localStorage.getItem(FontAwesomeService.storagePrefix + key);
    }
    catch {
      return null;
    }
  }

  private store(key: string, svg: string) {
    try {
      if (typeof localStorage !== 'undefined') localStorage.setItem(FontAwesomeService.storagePrefix + key, svg);
    }
    catch { }
  }
}
